export const SET_EMAIL_REQUEST_DATA = `SET_EMAIL_REQUEST_DATA`
export const SET_DL_UPLOADED = `SET_DL_UPLOADED`
export const SET_DL_SAVED = `SET_DL_SAVED`
export const MODAL_TYPE = `MODAL_TYPE`
export const SET_REQUESTID = `SET_REQUESTID`
export const TEMPLATE_TYPE = `TEMPLATE_TYPE`
export const SET_MASS_EMAIL_DATA = `SET_MASS_EMAIL_DATA`
export const SET_SCHEDULE_MASS_EMAIL_DATA = `SET_SCHEDULE_MASS_EMAIL_DATA`
export const SET_USE_TEMPLATE = `SET_USE_TEMPLATE`

export const SET_EMAIL_DLFILENAME = `SET_EMAIL_DLFILENAME`;
export const SET_EMAIL_SELECTEDDLFILE = `SET_EMAIL_SELECTEDDLFILE`;
export const SET_REQUEST_CANCELED = `SET_REQUEST_CANCELED`;
export const SET_ORIGIN = `SET_ORIGIN`;
export const SET_SAVEREQUEST = `SET_SAVEREQUEST`;
export const SET_TEMPLATE_CHANGE = `SET_TEMPLATE_CHANGE`;


export const setTemplateChange = (data) => ({
    type: SET_TEMPLATE_CHANGE,
    value: data
});

export const setSaveRequest = (data) => ({
    type: SET_SAVEREQUEST,
    value: data
});

export const setOrigin = (data) => ({
    type: SET_ORIGIN,
    value: data
});
export const setEmailDlFileName = (data) => ({
    type: SET_EMAIL_DLFILENAME,
    value: data
});
export const setRequestCanceled = (data) => ({
    type: SET_REQUEST_CANCELED,
    value: data
});
export const setUseTemplateStatus = (data) => ({
    type: SET_USE_TEMPLATE,
    value: data
});


export const setEmailSelectedDlFile = (data) => ({
    type: SET_EMAIL_SELECTEDDLFILE,
    value: data
});

export const setModalType = (data) => ({
    type: MODAL_TYPE,
    value: data
})
export const setRequestId = (data) => ({
    type: SET_REQUESTID,
    value: data
})

export const setTemplateType = (data) => ({
    type: TEMPLATE_TYPE,
    value: data
})



export const setDlUploadStatus = (data) => ({
    type: SET_DL_UPLOADED,
    value: data
})

export const setDlSaveStatus = (data) => ({
    type: SET_DL_SAVED,
    value: data
})

export const setSendEmailRequestData = (data) => ({
    type: SET_EMAIL_REQUEST_DATA,
    value: data
})


export const setMassEmailData = (status,message) => ({
    type: SET_MASS_EMAIL_DATA,
    text: message,
    status: status,
})


export const setScheduleMassEmailData = (status,message) => ({
    type: SET_SCHEDULE_MASS_EMAIL_DATA,
    text: message,
    status: status,
})






